import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["state", "tabIndex", "hideOnInteractOutside"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { matches } from 'ariakit-utils/dom';
import { createHook, createComponent, createElement } from 'ariakit-utils/system';
import { usePopover } from '../popover/popover.js';
import { useComboboxList } from './combobox-list.js';

function isController(target) {
  if (!target) return false;

  if ("id" in target) {
    for (var _len = arguments.length, ids = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      ids[_key - 1] = arguments[_key];
    }

    var selector = ids.filter(Boolean).map(function (id) {
      return "[aria-controls=\"" + id + "\"]";
    }).join(", ");
    if (!selector) return false;
    return matches(target, selector);
  }

  return false;
}
/**
 * A component hook that returns props that can be passed to `Role` or any other
 * Ariakit component to render a combobox popover.
 * @see https://ariakit.org/components/combobox
 * @example
 * ```jsx
 * const state = useComboboxState();
 * const props = useComboboxPopover({ state });
 * <Role {...props}>
 *   <ComboboxItem value="Item 1" />
 *   <ComboboxItem value="Item 2" />
 *   <ComboboxItem value="Item 3" />
 * </Role>
 * ```
 */


var useComboboxPopover = createHook(function (_ref) {
  var state = _ref.state,
      tabIndex = _ref.tabIndex,
      _ref$hideOnInteractOu = _ref.hideOnInteractOutside,
      _hideOnInteractOutside = _ref$hideOnInteractOu === void 0 ? true : _ref$hideOnInteractOu,
      props = _objectWithoutProperties(_ref, _excluded);

  props = useComboboxList(_objectSpread({
    state: state
  }, props));
  props = usePopover(_objectSpread(_objectSpread({
    state: state,
    autoFocusOnShow: false,
    autoFocusOnHide: false,
    finalFocusRef: state.baseRef
  }, props), {}, {
    // Combobox popovers can't be modal because the focus may be (and is by
    // default) outside of it on the combobox input element.
    modal: false,
    // Make sure we don't hide the popover when the user interacts with the
    // combobox cancel or the combobox disclosure buttons. They will have the
    // aria-controls attribute pointing to either the combobox input or the
    // comboobx popover elements.
    hideOnInteractOutside: function hideOnInteractOutside(event) {
      var _state$contentElement, _state$baseRef$curren;

      var contentId = (_state$contentElement = state.contentElement) == null ? void 0 : _state$contentElement.id;
      var baseId = (_state$baseRef$curren = state.baseRef.current) == null ? void 0 : _state$baseRef$curren.id;
      if (isController(event.target, contentId, baseId)) return false;
      var result = typeof _hideOnInteractOutside === "function" ? _hideOnInteractOutside(event) : _hideOnInteractOutside;
      return result;
    }
  }));
  return props;
});
/**
 * A component that renders a combobox popover. The `role` prop is set to
 * `listbox` by default, but can be overriden by any other valid combobox popup
 * role (`listbox`, `menu`, `tree`, `grid` or `dialog`). The `aria-labelledby`
 * prop is set to the combobox input element's `id` by default.
 * @see https://ariakit.org/components/combobox
 * @example
 * ```jsx
 * const combobox = useComboboxState();
 * <Combobox state={combobox} />
 * <ComboboxPopover state={combobox}>
 *   <ComboboxItem value="Item 1" />
 *   <ComboboxItem value="Item 2" />
 *   <ComboboxItem value="Item 3" />
 * </ComboboxPopover>
 * ```
 */

var ComboboxPopover = createComponent(function (props) {
  var htmlProps = useComboboxPopover(props);
  return createElement("div", htmlProps);
});
export { ComboboxPopover, useComboboxPopover };